goog.provide('el8.ext.onboarding.manualSignup');

goog.require('el8.ext.Form');
goog.require('el8.ext.onboarding.ButtonSet');
goog.require('el8.ext.onboarding.notDoctorDialog');
goog.require('el8.ext.util');
goog.require('el8.template.ext.onboarding.manualSignup');
goog.require('el8.uiwidget.NewPasswordFields');
goog.require('el8.util.base');
goog.require('el8.util.string');


el8.ext.onboarding.manualSignup.init = function() {

    var $container = $('#form-onboarding').removeClass('dataLoading');
    $container.html(el8.template.ext.onboarding.manualSignup.content({
        activating: el8.util.getUrlParam('activate')
    }));

    var $form = $('form', $container);
    var manualProfileFields = [
        'firstName', 'middleName', 'lastName', 'suffix',
        'address', 'suite', 'city', 'state', 'zip',
        'phone', 'fax', 'npi'
    ];

    var validationOpts = el8.ext.util.validationOpts();
    validationOpts['errorPlacement'] = function(error, element) {
        var name = $(element).attr('name');
        if (name === 'state' || name === 'zip') {
            var $existing = $('.error-msg[data-name="'+name+'"]', $container)
                .addClass('el8AlertText');
            $existing.text($(error).text());

        // as normal
        } else {
            $(error).attr('data-name', name);
            var $existing = $(element).prev('.error-msg');
            if ($existing.length) {
                $existing.replaceWith($(error));
            } else {
                $(error).insertBefore($(element));
            }
        }
    };
    validationOpts['unhighlight'] = function(element, errorClass) {

        el8.ext.util.unhighlightError($(element));

        var name = $(element).attr('name');
        if (name === 'state' || name === 'zip') {
            $('.error-msg[data-name="'+name+'"]', $container).empty();
        // as normal
        } else {
            $(element).prevAll('.error-msg').empty();
        }
    };

    var that = new el8.ext.Form({
        container: $form,
        name: 'quick-signup',
        buttonElt: $('.onboarding-signup-buttons', $form),
        buttonSetConstructor: el8.ext.onboarding.ButtonSet,
        validationOpts: validationOpts,
        fields: [
            {
                name: 'firstName',
                selector: ':input[name="firstName"]',
                infoText: 'First Name...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'middleName',
                selector: ':input[name="middleName"]',
                infoText: 'Middle Name (optional)...',
                size: 'large',
                maxLength: 35
            },
            {
                name: 'lastName',
                selector: ':input[name="lastName"]',
                infoText: 'Last Name...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'suffix',
                selector: ':input[name="suffix"]',
                infoText: 'Suffix (optional)...',
                size: 'large',
                maxLength: 10
            },
            {
                name: 'address',
                selector: ':input[name="address"]',
                infoText: 'Practice Address...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'suite',
                selector: ':input[name="suite"]',
                infoText: 'Suite or Apartment No. (optional)...',
                size: 'large',
                maxLength: 10
            },
            {
                name: 'city',
                selector: ':input[name="city"]',
                infoText: 'City...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'state',
                selector: ':input[name="state"]',
                infoText: 'State...',
                maxLength: 2,
                size: 'large',
                validate: {
                    state: true,
                    required: true
                },
                validateMsgs: {
                    state: 'Not a valid US state',
                    required: 'Required Field'
                }
            },
            {
                name: 'zip',
                selector: ':input[name="zip"]',
                infoText: 'Zip Code...',
                maxLength: 10,
                size: 'large',
                validate: {
                    zip: true,
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'phone',
                selector: ':input[name="phone"]',
                infoText: 'e.g. 555-555-5555...',
                size: 'large',
                maxLength: 15,
                validate: {
                    phone: true,
                    required: true
                },
                validateMsgs: {
                    phone: 'Not a valid US phone number',
                    required: 'Required Field'
                }
            },
            {
                name: 'fax',
                selector: ':input[name="fax"]',
                infoText: 'e.g. 555-555-5555 (optional)...',
                size: 'large',
                maxLength: 15,
                validate: {
                    phone: true
                },
                validateMsgs: {
                    phone: 'Not a valid US phone number'
                }
            },
            {
                name: 'npi',
                selector: ':input[name="npi"]',
                maxLength: 10,
                size: 'large',
                infoText: '10-digit NPI...',
                validate: {
                    exactlength: 10,
                    digits: true,
                    required: true,
                    remote: {
                        url: el8.service.urls.get('validNpi'),
                        type: 'GET'
                    }
                },
                validateMsgs: {
                    exactlength: 'Must be exactly 10 digits',
                    digits: 'Can only contain digits',
                    required: 'Required Field',
                    remote: 'NPI Already Taken'
                }
            },
            {
                name: 'email',
                selector: ':input[name="email"]',
                infoText: 'e.g. abc@xyz.com...',
                size: 'large',
                maxLength: 75,
                validate: {
                    required: true,
                    email: true,
                    remote: {
                        url: el8.service.urls.get('validEmail'),
                        type: 'GET'
                    }
                },
                validateMsgs: {
                    required: 'Required Field',
                    remote: 'Email Already Taken'
                }
            },
            {
                name: 'password1',
                selector: ':input[name="password1"]',
                infoText: 'Your password...',
                size: 'large',
                maxLength: 20,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'password2',
                selector: ':input[name="password2"]',
                infoText: 'Your password again...',
                size: 'large',
                maxLength: 20,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            }
        ]
    });

    var super_init = that._init;
    that._init = function() {

        super_init.call(that);

        (new el8.uiwidget.NewPasswordFields({
            field1: $(':input[name="password1"]', $container),
            selectorFn1: function($elt) { return $elt.prevAll('.error-msg'); },
            field2: $(':input[name="password2"]', $container),
            selectorFn2: function($elt) { return $elt.prevAll('.error-msg'); }
        })).init();

        $container.on('click', '.not-doctor-trigger',  function() {
            el8.ext.onboarding.notDoctorDialog.show();
        });
    };

    var super_isValid = that.isValid;
    that.isValid = function() { // over-ride
        return super_isValid.call(that) && !$('.has-error', $container).length;
    };

    /**
     * Get invitation id from cookie, if exists
     */
    that._getInvitationId = function() {
        Cookies.json = true;
        var cookie = Cookies.get("invitation");
        if (cookie) { return cookie.id; }
        return null;
    };

    /**
     * Helper methods
     */
    that._addSignupButton = function() {
        that.addButton('signup', 'Sign Up', function(_form, $btn) {
            if (that.isValid()) {
                $('.button-alert-text', $container).remove();
                $btn.prop('disabled', true);
                var mapped = {};
                var manualProfile = _form.getMappedFields(manualProfileFields);
                manualProfile['credential'] = 'MD'; //reduce fields in UI
                manualProfile['licenseState'] = ''; //reduce fields in UI
                manualProfile['licenseNumber'] = ''; //reduce fields in UI
                manualProfile['fax'] = el8.util.string.cleanPhoneNum(manualProfile['fax']);
                manualProfile['phone'] = el8.util.string.cleanPhoneNum(manualProfile['phone']);
                mapped['manual_profile'] = manualProfile;
                var fullName =
                    _form.getVal('firstName') +
                    (_form.getVal('middleName') ? ' '+_form.getVal('middleName') : '') +
                    ' '+_form.getVal('lastName') +
                    (_form.getVal('suffix') ? ' '+_form.getVal('suffix') : '');
                olark && olark('api.visitor.updateFullName', {fullName: fullName});
                mapped['email'] = _form.getVal('email');
                mapped['password'] = _form.getVal('password1');
                mapped['complete'] = true;
                mapped['invitation_id'] = that._getInvitationId();
                var activating = el8.util.getUrlParam('activate');
                $.el8_ajax({
                    type: 'POST',
                    async: false, // need to have an ID
                    data: {data: JSON.stringify(mapped)},
                    url: el8.service.urls.get('signup', [null, activating]),
                    success: function(data) {
                        window.location.href = el8.service.urls.get('signupComplete', [activating]);
                    },
                    error: function() {
                        window.location.href = el8.service.urls.get('signupError', [activating]);
                    }
                });
            } else {
                $('.button-alert-text', $container).remove();
                $btn.after(el8.template.ext.onboarding.manualSignup.errorMsgButton());
            }
        }, true, true);
        that.renderButtonSet();
    };

    that._removeSignupButton = function() {
        that.removeButton('signup');
        that.renderButtonSet();
    };

    // Do stuff to show the form

    that.render();
    that._addSignupButton();

    // Pre-populate name user searched, if any
    var nameSearched = el8.util.getUrlParam('name');
    if (nameSearched) {
        var names = nameSearched.split(' ');
        that.setVal('firstName', names[0].capitalize());
        if (names.length > 2) {
            that.setVal('middleName', names[1].capitalize());
            that.setVal('lastName', names.slice(2, names.length).join(' ').capitalize());
        } else if (names.length > 1) {
            that.setVal('lastName', names.slice(1, names.length).join(' ').capitalize());
        }
    }

    that.focusField('firstName');
};
